import React, { useEffect } from 'react'
import Navbar from "../../Components/Navbar";
import { Link } from 'react-router-dom';
import { expend_mock1, project_mockup1, project1Mockup1, project1Mockup2, project1Mockup3, narrateMedia2, narrateMedia3, narrateMediaBanner } from '../../Assets';


const Project1 = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className='project-details-app-main-wrapper'>
                <Navbar />
                <div className="projects-details-cover-wrapper">
                    <div className="container">
                        <div className="project-details-content-cover">
                            <div className='project-det-hero-cover'>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='project-det-title'>
                                            <h3>Narrate Media
                                            </h3>
                                            <div className="project-infographics-cover">
                                                <div className="project-info-pills-cover">
                                                    <div className="project-info-pills">
                                                        <p>18 April</p>
                                                    </div>
                                                    <div className="project-info-pills">
                                                        <p>
                                                            <Link to="https://www.narratemedia.in/">
                                                                Link
                                                            </Link>
                                                        </p>
                                                    </div>
                                                    <div className="project-info-pills">
                                                        <p>Client</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className='project-det-short-summary'>
                                            <p>Narrate Media is a sleek, modern website built with React (Vite) and Tailwind CSS, showcasing innovative storytelling services for brands and businesses. It features a clean design, smooth performance, and a user-friendly experience to highlight Narrate Media’s creative expertise.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='projects-det-cards-cover'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="proj-small-card-cover">
                                            <div className="proj-small-card">
                                                <img src={narrateMedia2}></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="proj-high-card-cover">
                                            <div className="proj-small-card">
                                                <img src={narrateMediaBanner}></img>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="proj-small-card-cover">
                                            <div className="proj-small-card">
                                                <img src={narrateMedia3}></img>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="projects-description-cover-box">

                                <div className="projects-description-content-cover">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="projects-description-content-box">
                                                <div className="projects-title-header">
                                                    <h2>Project Description</h2>
                                                </div>
                                                <div className="projects-description-content">
                                                    <p>Narrate Media is a professionally crafted digital platform designed to showcase the creative storytelling services provided by Narrate Media. Built using React.js with the Vite build tool and styled using Tailwind CSS, the website exemplifies a modern, lightweight, and highly responsive user experience.</p>
                                                    <p>
                                                        This project not only serves as a platform for Narrate Media to reach its audience but also stands as a strong portfolio piece showcasing expertise in frontend development and modern web design principles
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className="projects-skills-cover">
                                                <h5>Skills</h5>
                                                <div className='projects-skills-pills-cover'>
                                                    <div className='project-skills-pills'>
                                                        <p>Minimal Design</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>Ui/Ux</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>Tailwind css</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>Custom Animation</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>useEffect Hooks</p>
                                                    </div>
                                                    <div className='project-skills-pills'>
                                                        <p>React Router Dom</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Project1